import Widget from "lib/widget"
import $ from 'jquery';

class ChecklistCarousel extends Widget {
  bind() {
    checklistsCarousel.call(this);
    bindNavDropdownOverflow.call(this);
  }
}

function showSlide($slider, $slide) {
  if (!$slide || !$slide.length) return;
  $slider.find('.checklist-slider').removeClass('is-active-slide');
  $slide.addClass('is-active-slide');
}

function resolveInitialSlide($slider) {
  const $slides = $slider.find('.checklist-slider');
  if (!$slides.length) return $slides;

  if (window.gon && gon.project && gon.project.checklist_id) {
    const targetSlide = $slides.filter(`[data-checklist-id="${gon.project.checklist_id}"]`);
    if (targetSlide.length) return targetSlide;
  }

  const currentSlide = $slides.filter('[data-slider-current="true"]');
  if (currentSlide.length) return currentSlide;

  if ($slider.attr('data-carousel-start') === 'last') {
    return $slides.last();
  }

  return $slides.first();
}

function goToCurrentStage($slider) {
  const $slides = $slider.find('.checklist-slider');
  if (!$slides.length) return $slides;

  const currentSlide = $slides.filter('[data-slider-current="true"]');
  return currentSlide.length ? currentSlide : $slides.last();
}

function goToChecklistId($slider, checklistId) {
  if (checklistId === undefined || checklistId === null) return;
  showSlide($slider, $slider.find(`.checklist-slider[data-checklist-id="${checklistId}"]`));
}

let checklistsCarousel = function() {
  const $slider = $('#slick-checklist-slider');
  const root = this.root;

  showSlide($slider, resolveInitialSlide($slider));

  root.find('a[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
    if ($(e.target).attr('href') === '#checklists-main-tab') {
      showSlide($slider, goToCurrentStage($slider));
    }
  });

  const $checklistTabLink = root.find('#checklists-main-tab-link');
  if ($checklistTabLink.length) {
    $checklistTabLink.on('click', function () {
      if (!$checklistTabLink.hasClass('active')) return;
      showSlide($slider, goToCurrentStage($slider));
    });
  }

  root.on('click', '.js-checklist-nav-pick', (e) => {
    e.preventDefault();
    const checklistId = $(e.currentTarget).data('checklist-id');
    if (checklistId === undefined || checklistId === null) return;

    const hideMenu = () => {
      const bootstrap = window.bootstrap;
      const toggle = $(e.currentTarget).closest('.dropdown').find('[data-bs-toggle="dropdown"]')[0];
      if (bootstrap && toggle && bootstrap.Dropdown.getOrCreateInstance) {
        bootstrap.Dropdown.getOrCreateInstance(toggle).hide();
      }
    };

    const navigate = () => {
      goToChecklistId($slider, checklistId);
      hideMenu();
    };

    const tabEl = document.querySelector('#checklists-main-tab-link');
    const bootstrap = window.bootstrap;
    if (tabEl && bootstrap && !tabEl.classList.contains('active')) {
      $(tabEl).one('shown.bs.tab', navigate);
      bootstrap.Tab.getOrCreateInstance(tabEl).show();
    } else {
      navigate();
    }
  });
};

// Safari clips position:fixed dropdowns inside overflow:auto scroll containers.
// Temporarily opening overflow to visible while the menu is shown lets it escape.
let bindNavDropdownOverflow = function() {
  this.root.find('.proj-nav-container [data-bs-toggle="dropdown"]').each(function() {
    const container = $(this).closest('.proj-nav-container')[0];
    if (!container) return;
    this.addEventListener('show.bs.dropdown', () => {
      container.style.overflow = 'visible';
    });
    this.addEventListener('hidden.bs.dropdown', () => {
      container.style.overflow = '';
    });
  });
};

export default ChecklistCarousel
